<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="normal"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>编辑</template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          label-width="80px">
        <el-form-item
            label="品类名称"
            prop="name"
            :rules="[
              { required: true, message: '请输入品牌名称', trigger: ['blur', 'change'] },
              { max: 60, message: '长度不能大于60个字符', trigger: ['blur', 'change'] }
            ]">
          <gj-input
              v-model="form.name"
              class="form-input"
              width="100%"
          ></gj-input>
        </el-form-item>
        <el-form-item
            label="所属上级"
            prop="parentId">
          <gj-tree-select
              v-model="form.parentId"
              :data="treeData.tree"
              :clearable="true"
              class="form-input"
              width="100%"
          ></gj-tree-select>
        </el-form-item>
        <el-form-item
            label="描述"
            style="margin-bottom: 0;"
            prop="memo">
          <gj-textarea
              v-model="form.memo"
              :styles="{height: '120px', width: '100%'}"
              class="form-input">
          </gj-textarea>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "../../../../../minxins";
  import {productCategoryStore} from "../store";
  import {defaultVal} from "../../../../../utils/common";
  import {updateProductCategory} from "../../../../../api/product";

  export default {
    name: "app-product-category-edit-modal",
    mixins: [modalMixIn],
    props: {
      category: {
        required: true
      }
    },
    data() {
      return {
        confirmLoading: false,
        form: {
          name: null,
          memo: null
        },
        // productCategoryStore: productCategoryStore,
       data: productCategoryStore,
       treeData: {}

      }
    },
    created() {
      const tree = [];
      this.data.tree.filter(item => {
      if (this.category.id !== item.id) {
        tree.push(item);
        this.treeData = { tree };
        return this.treeData;
      }
    })
      this.form.name = this.category.name;
      this.form.parentId = this.category.pid;
      this.form.memo = this.category.memo;
    },
    methods: {
      confirm() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.confirmLoading = true;
            updateProductCategory({
              id: this.category.id,
              pid: this.form.parentId,
              name: this.form.name,
              memo: defaultVal(this.form.memo, null),
            })
              .then(() => {
                this.$emit('updated');
                this.$gjDestroy();
              })
              .complete(() => this.confirmLoading = false);
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
</style>
